import React from "react";

// Official-ish WhatsApp glyph as inline SVG (no external dependency)
export default function WhatsAppIcon({ className = "w-5 h-5" }) {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="currentColor"
        d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.802 2.722.802.945 0 2.92-.616 3.323-1.59.231-.583.13-1.029-.057-1.475-.144-.345-.43-.487-.832-.66-.358-.135-1.118-.4-1.418-.4Z"
      />
      <path
        fill="currentColor"
        d="M16.002 0C7.165 0 .002 7.163.002 16c0 2.685.66 5.31 1.913 7.65L0 32l8.555-2.273A15.928 15.928 0 0 0 16.002 32C24.838 32 32 24.837 32 16S24.838 0 16.002 0Zm0 29.276c-2.34 0-4.638-.616-6.65-1.79l-.476-.283-4.985 1.32 1.347-4.86-.305-.5A13.231 13.231 0 0 1 2.724 16C2.724 8.69 8.69 2.724 16.002 2.724S29.28 8.69 29.28 16s-5.966 13.276-13.278 13.276Z"
      />
    </svg>
  );
}
